import { render } from "./PledgeDefinition.vue?vue&type=template&id=09825ecc&scoped=true"
import script from "./PledgeDefinition.vue?vue&type=script&lang=js"
export * from "./PledgeDefinition.vue?vue&type=script&lang=js"

import "./PledgeDefinition.vue?vue&type=style&index=0&id=09825ecc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09825ecc"]])

export default __exports__